/* _customled-fitment-cta-promote.js — M1.9.10
 *
 * Promotes the "Find My Relay" fitment CTA (and any sibling
 * .customled-relay-collection-intro / .customled-fitment-cta block) out of
 * the .collection-description container on collection pages so it is
 * NEVER hidden by the description's "Number of lines to show" truncation.
 *
 * Without this script the fitment CTA is rendered as part of the
 * merchant-managed collection description HTML, which means the
 * main-collection-banner section's description_lines_to_show toggle
 * clips it out of view when the description is collapsed. The fitment
 * CTA is the primary call-to-action on the relay collection page, so it
 * must always be visible regardless of how the description is configured.
 *
 * Mechanism: find each .customled-relay-collection-intro (preferred — our
 * owned wrapper, scoping the move precisely) OR .customled-fitment-cta
 * (fallback if no wrapper) that lives inside a .collection-description,
 * and re-parent it as the description's preceding sibling. Idempotent —
 * a second run finds no orphans and is a no-op.
 *
 * No coupling to the read-more JS or to vendor section internals; we
 * just rearrange DOM once on DOMContentLoaded.
 */
(function () {
  'use strict';

  function promote() {
    // Move ONLY the .customled-fitment-cta element itself, not any wrapper
    // it might be inside. The merchant's collection description HTML wraps
    // the fitment CTA plus other body text in a shared parent
    // (.customled-relay-collection-intro), so lifting that wrapper would
    // also remove the body text from the truncation container and break
    // the read-more behavior. Lifting just the .customled-fitment-cta
    // leaves the wrapper + body text inside .collection-description so
    // description truncation continues working normally.
    var nodes = document.querySelectorAll(
      '.collection-description .customled-fitment-cta'
    );
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      var desc = node.closest('.collection-description');
      if (!desc || !desc.parentElement) continue;
      if (node.__customledPromoted) continue;
      node.__customledPromoted = true;
      desc.parentElement.insertBefore(node, desc);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', promote);
  } else {
    promote();
  }
})();
